"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AlertForm } from "@/app/_components/alert-form";

import { useFilter } from "../use-filter";

import type { Uf } from "@/types";

interface Props extends Uf {
  children: React.ReactNode;
}

export const CreateAlert = ({ children, uf }: Props) => {
  const [
    {
      cidade,
      tipo,
      modalidade,
      precoMin,
      precoMax,
      pagamento,
      tamanhoArea,
      tamanhoPropriedade,
    },
  ] = useFilter();

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="overflow-auto w-full sm:max-w-5xl h-full sm:max-h-[95%] sm:min-h-[400px] sm:h-auto">
        <DialogHeader>
          <DialogTitle>Configurar alerta</DialogTitle>
          <DialogDescription>
            Preencha as informações abaixo para receber alertas personalizados
            sobre imóveis. O alerta será enviado sempre pela manhã.
          </DialogDescription>
          <div className="pt-6">
            <AlertForm
              data={{
                blockType: "",
                titulo: "",
                email: "",
                telefone: "",
                uf,
                cidades: cidade.toString(),
                endereco: null,
                bairros: null,
                area: tamanhoArea || tamanhoPropriedade,
                dias_faltantes_leilao: null,
                tipo,
                modalidade_de_venda: modalidade,
                pagamento,
                preco_min: precoMin,
                preco_max: precoMax,
                desconto: null,
              }}
            />
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
